import React, {useEffect, useState} from 'react';
import axios from "axios";
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar} from "../../../../../../../../components/sfr/maydon";
import {header} from "../../../../../../../../components/api/Header";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import { getEnv } from "../../../../../../../../lib/env";

function Limit1() {
    const lkoifsent = localStorage.getItem('sfr-hm-noveg-koifsent')?localStorage.getItem('sfr-hm-noveg-koifsent'):1
    const user = user_data()
    const year = localStorage.getItem('sfr-hm-year')?localStorage.getItem('sfr-hm-year'):new Date().getFullYear()
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const [swed, setSwed] = useState({})
    const ekin = localStorage.getItem("sfr-hm-noveg-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const ste1 = localStorage.getItem("sfr-hm-ste")
    const ste = ste1?JSON.parse(ste1):{}
    const sfrMaydon = localStorage.getItem("sfr-hm-noveg-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const [maydonlar, setMaydonlar] = useState({})
    const daysindek = decade_days('noveg',year)
    const cropid = localStorage.getItem('sfr-hm-noveg-ekinids')
    const cropids = cropid?JSON.parse(cropid):[]
    useEffect(()=>{
        let gmss = []
        const fetchSwed = async (gmss,gmss2) => {
            const postData = {
                crops:cropids,
                gmss,
                maydonlar:gmss2,
                tomorqa1:false
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/noveg_sugorish_meyyori2",
                postData,
                header()
            )
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSwed(res.data)
            }
        }
        const maydon = () => {
            let gidromodullar = []
            istemolchilar.map(i=>{
                if(i.gms){
                    i.gms.map(g=>{
                        if(!gidromodullar.includes(g)){
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydon()
        const gmss2 = gmslar(sfrMaydonlar,cropids)
        setMaydonlar(gmss2)
        if(gmss2)
            fetchSwed(gmss,gmss2)
    },[])

    const ff = (ist) => {
        let res = 0
        Object.keys(ekinlar).map(e=>{
            for(let deks = 1; deks < 19; deks++){
                if(swed[e.slice(1)]){
                    if(ist.gms){
                        let ed = 0
                        ist.gms.map(gms2=>{
                            if(swed[e.slice(1)][gms2]){
                                let jm = maydonlar['g'+gms2]?maydonlar['g'+gms2][e]:0
                                let im = sfrMaydonlar['i'+ist.id]?sfrMaydonlar['i'+ist.id]['g'+gms2]?sfrMaydonlar['i'+ist.id]['g'+gms2][e]:0:0
                                let ds = swed[e.slice(1)][gms2][deks]
                                ed = addFunc(ed,(bolFunc(im,jm)*ds))
                            }
                        })
                        res = addFunc(res,bolFunc(ed,ist.fik))
                    }
                }
            }
        })
        return res
    }
    const xisobot = () => {
        let obj = [];
        let counter = 1;
        let js = [0,0,0,0,0,0,0,0,0]
        manbalar.map((manba,m)=> {
            js = [0,0,0,0,0,0,0,0,0]
            let istemolchi = istemolchilar.filter(istemolchi => istemolchi.mid == manba.id)
            if (istemolchi.length) {
                istemolchi.map(ist=>{
                    let iks = ff(ist)
                    let rd = bolFunc(iks,1000)*lkoifsent
                    js[0] = addFunc(js[0],rd)
                    js[1] = addFunc(js[1],rd)
                    obj.push(
                        <tr key={counter}>
                            <td>{counter++}</td>
                            <td className="text-start">{ist.name}</td>
                            <td className="text-center">{fixIt(rd,3)}</td>
                            <td className="text-center">{fixIt(rd,3)}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    )
                })
                let sanoats = ste.filter(st=>st.manba==manba.id)
                if(sanoats.length){
                    sanoats.map(sanoat=>{
                        let es = [0,0,0,0,0,0,0,0,0]
                        const fik = manba.fik
                        let sol = 0
                        for(var si = 1; si < 19; si++){
                            let l52 = sanoat['d'+si] * (0.0864 * daysindek['d'+si])
                            sol = addFunc(sol,l52)
                        }
                        let res = bolFunc(bolFunc(sol,1000),fik)
                        js[0] = addFunc(js[0],res)
                        js[2] = addFunc(js[2],res)
                        es[0] = res
                        es[1] = ''
                        es[2] = res
                        switch (sanoat.yonalish){
                            case "1": es[5] = res; js[5] = addFunc(js[5],res); break;
                            case "2": es[6] = res; js[6] = addFunc(js[6],res); break;
                            case "3": es[7] = res; js[7] = addFunc(js[7],res); break;
                            case "4": es[6] = res; js[6] = addFunc(js[6],res); break;
                            case "5": es[3] = res; es[4] = sanoat.q; js[3] = addFunc(js[3],res); js[4] = addFunc(js[4],sanoat.q);break;
                            case "6": es[8] = res; js[8] = addFunc(js[8],res);break;
                        }
                        obj.push(
                            <tr key={counter}>
                                <td>{counter++}</td>
                                <td className="text-start">{sanoat.name}</td>
                                <td className="text-center">{fixIt(res,3)}</td>
                                <td className="text-center"></td>
                                <td className="text-center">{fixIt(res,3)}</td>
                                <td className="text-center">{es[3]?fixIt(es[3],3):''}</td>
                                <td className="text-center">{es[4]?fixIt(es[4],3):''}</td>
                                <td className="text-center">{es[5]?fixIt(es[5],3):''}</td>
                                <td className="text-center">{es[6]?fixIt(es[6],3):''}</td>
                                <td className="text-center">{es[7]?fixIt(es[7],3):''}</td>
                                <td className="text-center">{es[8]?fixIt(es[8],3):''}</td>
                            </tr>
                        )
                    })
                }
                obj.push(
                    <tr key={m+'m'}>
                        <th colSpan={2}>{manba.name}</th>
                        <th className="text-center">{fixIt(js[0],3)}</th>
                        <th className="text-center">{fixIt(js[1],3)}</th>
                        <th className="text-center">{fixIt(js[2],3)}</th>
                        <th className="text-center">{js[3]?fixIt(js[3],3):''}</th>
                        <th className="text-center">{js[4]?fixIt(js[4],3):''}</th>
                        <th className="text-center">{js[5]?fixIt(js[5],3):''}</th>
                        <th className="text-center">{js[6]?fixIt(js[6],3):''}</th>
                        <th className="text-center">{js[7]?fixIt(js[7],3):''}</th>
                        <th className="text-center">{js[8]?fixIt(js[8],3):''}</th>
                    </tr>
                )
            }

        })
        return obj;
    }
    return (

            <div className="row">
                <div className="col-12">
                    <table className="table table-borderless">
                        <thead>
                        <tr>
                            <td colSpan={11}><h3 className="text-center">Limit - №1</h3></td>
                        </tr>
                        <tr>
                            <td colSpan={11}>
                                <h4 className="text-center">
                                    {user.district} bo'yicha {year} - {parseInt(year)+1} yil nosug'orish davrida suv manbalaridan olinadigan cheklangan suv miqdori (limit)
                                </h4>
                            </td>
                        </tr>
                        </thead>
                    </table>
                    <div className="text-end pe-5 mx-auto"  style={{maxWidth:"1100px"}}>mln.m<sup>3</sup></div>
                    <div className="flex-box mx-auto"  style={{maxWidth:"1100px"}}>
                        <div className="xisobotTable">
                            <table className="table table-bordered text-center xisobot3">
                                <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                                <tr>
                                    <th rowSpan={4} className="vertical-middle">No</th>
                                    <th rowSpan={4} style={{minWidth:"170px"}} className="vertical-middle">Hududlar nomi</th>
                                    <th rowSpan={4} className="vertical-middle">Nosug'orish davrida olinadigan cheklangan suv miqdori</th>
                                    <th colSpan={8} className="vertical-middle">Shu jumladan</th>
                                </tr>
                                <tr>
                                    <th rowSpan={3} className="vertical-middle">Sug'orishga</th>
                                    <th rowSpan={3} className="vertical-middle">Sanoat, KMRX va boshqa extiyojlarga</th>
                                    <th colSpan={6} className="vertical-middle">Shu jumladan</th>
                                </tr>
                                <tr>
                                    <th colSpan={2} className="vertical-middle">Energetika</th>
                                    <th rowSpan={2} className="vertical-middle">Sanoat</th>
                                    <th rowSpan={2} className="vertical-middle">KMRX</th>
                                    <th rowSpan={2} className="vertical-middle">Baliqchilik xo'jaligi</th>
                                    <th rowSpan={2} className="vertical-middle">Boshqalar</th>
                                </tr>
                                <tr>
                                    <th className="vertical-middle">Jami olinadigan</th>
                                    <th className="vertical-middle">Qaytmaydigan</th>
                                </tr>
                                </thead>
                                <tbody>
                                {xisobot()}
                                </tbody>

                            </table>

                        </div>
                    </div>

                </div>
            </div>
    );
}

export default Limit1;